import { Box, Grid } from '@mui/material'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { useVideoInstructionsQuery } from 'services/video-instructions'
import { VideoInstructionsCard } from './video-instructions-card'
import { useQueryState } from 'react-router-use-location-state'
import { TablePagination } from 'components/TablePagination'

export const VideoInstructionsList = () => {
  const [page, setPage] = useQueryState('page', 0)

  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
  } as const

  const {
    data: videoInstructions,
    isError,
    isLoading,
  } = useVideoInstructionsQuery(args)

  if (isLoading) return <Loading fullPage={false} />

  if (isError) return <Error />

  if (videoInstructions === undefined) {
    return <></>
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {videoInstructions.items.map((instruction) => (
          <Grid key={instruction.id} item xs={4}>
            <VideoInstructionsCard {...instruction} />
          </Grid>
        ))}
      </Grid>
      {videoInstructions.info.totalRows !== 0 && (
        <TablePagination
          total={videoInstructions.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </Box>
  )
}
